import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import { getPreSaleOrderWarehouseProductStore } from '@/api/modules/warehouse-management/warehouseStore';

export const getPreSaleUserUnPaidOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getPreSaleUserUnPaidOrderList',
        data: data,
        method: 'post'
    });
};
export const getPreSaleOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getPreSaleOrderList',
        data: data,
        method: 'post'
    });
};
export const getDepositBillOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getDepositBillOrderList',
        data: data,
        method: 'post'
    });
};

export const getPreSaleOrderDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getPreSaleOrderDetail',
        data: data,
        method: 'post'
    });
};

export const printPreSaleOrderDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/printPreSaleOrderDetail',
        data: data,
        method: 'post'
    });
};

export const exportPreSaleOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/exportPreSaleOrderList',
        data: data,
        method: 'post'
    });
};

export const getPreSaleOrderProductPlanList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getPreSaleOrderProductPlanList',
        data: data,
        method: 'post'
    });
};

export const withdrawPreSaleOrder = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/withdrawPreSaleOrder',
        data: data,
        method: 'post'
    });
};

export const getOrderDeliveryHistory = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getOrderDeliveryHistory',
        data: data,
        method: 'post'
    });
};

export const pageInit4PreSaleOrderDelivery = preSaleOrderRecordUuid => {
    return axiosRequest.all([
        getPreSaleOrderDetail({ preSaleOrderRecordUuid }),
        getPreSaleOrderWarehouseProductStore({ preSaleOrderRecordUuid }),
        getOrderDeliveryHistory({ preSaleOrderRecordUuid })
    ]).then(axiosRequest.spread(function (orderDetail, productStore, deliveryHistory) {
        if (orderDetail.code === 0 && productStore.code === 0 && deliveryHistory.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    orderDetail: orderDetail.data.orderDetail,
                    availableWeek: orderDetail.data.availableWeek,
                    productStore: productStore.data,
                    deliveryHistory: deliveryHistory.data
                }
            };
        }
    }));
};

export const savePreSaleDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/savePreSaleDelivery',
        data: data,
        method: 'post'
    });
};



export const updatePreSaleOrderBufferSetting = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/updatePreSaleOrderBufferSetting',
        data: data,
        method: 'post'
    });
};

export const zeroDeliveryPreSaleOrderDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/zeroDeliveryPreSaleOrderDetail',
        data: data,
        method: 'post'
    });
};

export const savePreSaleForwardDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/savePreSaleForwardDelivery',
        data: data,
        method: 'post'
    });
};

export const getPreSaleOrderRelateForwardDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/getPreSaleOrderRelateForwardDelivery',
        data: data,
        method: 'post'
    });
};

export const pageInit4PreSaleOrderDetail = preSaleOrderRecordUuid => {
    return axiosRequest.all([
        getPreSaleOrderDetail({ preSaleOrderRecordUuid }),
        getPreSaleOrderRelateForwardDelivery({ preSaleOrderRecordUuid })
    ]).then(axiosRequest.spread(function (orderDetail, forwardDelivery) {
        if (orderDetail.code === 0 && forwardDelivery.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    orderDetail: orderDetail.data.orderDetail,
                    availableWeek: orderDetail.data.availableWeek,
                    forwardDelivery: forwardDelivery.data
                }
            };
        }
    }));
};

export const getPreSaleForwardDeliveryDetail = preSaleForwardDeliveryRecordUuid => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/getPreSaleForwardDeliveryDetail',
        data: { preSaleForwardDeliveryRecordUuid },
        method: 'post'
    });
};

export const seedFarmSetResponse = data => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/seedFarmSetResponse',
        data: data,
        method: 'post'
    });
};

export const transToDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/transToDelivery',
        data: data,
        method: 'post'
    });
};

export const withdrawForwardDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/forwardDelivery/withdrawForwardDelivery',
        data: data,
        method: 'post'
    });
};

export const remarkOrderdeposite = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/remarkOrderdeposite',
        data: data,
        method: 'post'
    });
};

export const paybackOrderdeposite = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/paybackOrderdeposite',
        data: data,
        method: 'post'
    });
};

export const modifyPreSaleOrder = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/modifyPreSaleOrder',
        data: data,
        method: 'post'
    });
};

export const repayOrderdeposite = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/repayOrderdeposite',
        data: data,
        method: 'post'
    });
};
export const getUnPaidBackOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getUnPaidBackOrderList',
        data: data,
        method: 'post'
    });
};